    /**
     * USP List header scroll animation
     *
     * - `.background-title-large` is visible immediately and drifts upward on scroll
     * - `.background-title-small` fades/slides in a bit later and also moves upward
     */
    function initUspListScroll() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

        const sections = gsap.utils.toArray('.content__usp-list');
        if (!sections.length) return;

        sections.forEach(section => {
            const header = section.querySelector('.usp-list-header');
            if (!header) return;

            const bgLarge = header.querySelector('.background-title-large');
            const bgSmall = header.querySelector('.background-title-small');

            // Make the header start lower (overlapping the content below) and separate as you scroll
            gsap.fromTo(
                header,
                { yPercent: 50 },        // start pushed down, overlapping the list items
                {
                    yPercent: -10,       // end higher, separating from the content
                    ease: 'none',
                    scrollTrigger: {
                        trigger: section,
                        start: 'bottom bottom',
                        end: 'bottom top',
                        scrub: true
                        // markers: true
                    }
                }
            );

            if (bgSmall) {
                // Small background title: appears a bit later and moves up
                gsap.fromTo(
                    bgSmall,
                    { yPercent: 50, opacity: 0 },
                    {
                        yPercent: 0,
                        opacity: 1,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: section,
                            start: 'top center',   // slightly further into the scroll
                            end: 'top top',
                            scrub: true
                        }
                    }
                );
            }
        });
    }
